import React from 'react';
import { Link } from 'react-router-dom';
import Aurora from '../components/Aurora';
import '../components/Aurora.css';
import CountUp from '../components/CountUp';
import ScrollFloat from '../components/ScrollFloat';
import ShinyText from '../components/ShinyText';
import Banner from '../components/Banner';

import { researchTechStack } from '../data/techStack';



function HomePage() {
    return (
        <div className="aurora-container">
        { <Aurora
            colorStops={["#3A29FF", "#ACADBC", "#006A52"]}
            blend={0.5}
            amplitude={1.0}
            speed={0.5}
            />  }
        <div className="container home-container">
            <section className="hero">
                <img src="/assets/bendall-logo.png" alt="Bendall" className="hero-logo" />
                <span className="hero-text">Lab</span>
                <div className="hero-separator"></div>
                <div className="hero-buttons">
                    <Link to="/research" className="hero-btn">Explore Research</Link>
                    <Link to="/people" className="hero-btn">Meet The Team</Link>
                </div>
                <Banner
                    items={researchTechStack}
                    speed={40000}
                />
            </section>
            
            <section className="stats-section">
                <div className="stats-grid">
                    <div className="stat-item">
                        <CountUp
                            from={0}
                            to={150}
                            separator=","
                            direction="up"
                            duration={1}
                            className="count-up-text stat-number"
                            />
                        <div className="stat-label">Publications</div>
                    </div>
                    <div className="stat-item">
                        <CountUp
                            from={0}
                            to={25}
                            separator=","
                            direction="up"
                            duration={1}
                            className="count-up-text stat-number"
                            />
                        <div className="stat-label">Team Members</div>
                    </div>
                    <div className="stat-item">
                        <CountUp
                            from={0}
                            to={10}
                            separator=","
                            direction="up"
                            duration={1}
                            className="count-up-text stat-number"
                            />
                        <div className="stat-label">Active Projects</div>
                    </div>
                    <div className="stat-item">
                        <CountUp
                            from={0}
                            to={5}
                            separator=","
                            direction="up"
                            duration={1}
                            className="count-up-text stat-number"
                            />
                        <div className="stat-label">Years of Excellence</div>
                    </div>
                </div>
            </section>

            <section className="overview-section">
                <div className="section-heading">
                    <ScrollFloat
                        animationDuration={1}
                        ease='back.inOut(2)'
                        scrollStart='center bottom+=20%'
                        scrollEnd='bottom bottom-=40%'
                        stagger={0.03}
                        >
                        About Us
                    </ScrollFloat>
                    <p>Our laboratory is dedicated to pushing the boundaries of knowledge through innovative <ShinyText text="research" speed={3} />, collaborative <ShinyText text="partnerships" speed={4} />, and technological <ShinyText text="advancement" speed={3.5} />.</p>
                </div>

                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                                <path d="M9 7L12 4l3 3"/>
                                <path d="M12 4v12"/>
                            </svg>
                        </div>
                        <h3>Research Excellence</h3>
                        <p>Leading breakthrough research with state-of-the-art methodologies and innovative approaches to complex scientific challenges.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                <circle cx="9" cy="7" r="4"/>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                            </svg>
                        </div>
                        <h3>Collaborative Network</h3>
                        <p>Building partnerships across institutions and disciplines to foster innovation and accelerate scientific progress.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                            </svg>
                        </div>
                        <h3>Technology Innovation</h3>
                        <p>Developing and implementing cutting-edge technologies to advance research capabilities and scientific understanding.</p>
                    </div>
                </div>
            </section>


        </div>
        </div>
    );
}

export default HomePage;